module.exports = "/_next/static/images/62bc95244718beb1fce134cbae2789cb-sanpablo-3.jpg";